<script>
import Service from '../../../../domain/leiloes/services'
import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'

export default {
  name: 'email-automatico-view',
  data () {
    return {
      open: false,
      loading: true,
      leilaoId: null,
      lotes: [],
      tipoEnvio: {
        vendidos: false,
        condicionais: false,
        rejeitados: false
      },
      selecionarTudo: false,
      isSending: false,
      pointer: -1
    }
  },
  computed: {
    getStatus () {
      return Status.Status
    }
  },
  mounted () {
  },
  destroyed () {
    this._unmount()
  },
  methods: {
    load (leilaoId) {
      this.$leilaoId = leilaoId
      this.selecionarTudo = false
      this.tipoEnvio.vendidos = false
      this.tipoEnvio.condicionais = false
      this.tipoEnvio.rejeitados = false
      let _body = document.querySelector('body')
      _body.classList.add('hide-scroll')
      this.leilaoId = leilaoId
      Service.checaComunicacaoLote(leilaoId)
        .then((response) => {
          this.loading = false
          if (Array.isArray(response.data)) {
            this.lotes = response.data.slice().map(lote => {
              lote.checked = false
              return lote
            })
          }
          console.log(response)
        })
        .catch((error) => {
          window.responseError(error)
        })
      this.open = true
    },
    close () {
      this.open = false
      this._unmount()
    },
    _unmount () {
      this.htmlLoaded = false
      let _body = document.querySelector('body')
      _body.classList.remove('hide-scroll')
    },
    selectAll () {
      let checked = false
      this.$nextTick(() => {
        window.setTimeout(() => {
          if (this.selecionarTudo) {
            checked = true
          }
          this.lotes.forEach((lote, index) => {
            // this.lotes[index].checked = checked
            this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {checked: checked})) // Analisar desempenho
          })
        }, 100)
      })
    },
    checkTipos (t, v) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.lotes.forEach((lote, index) => {
            // this.lotes[index].checked = parseInt(lote.status) === v
            if (parseInt(lote.status) === v) {
              this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {checked: this.tipoEnvio[t]})) // Analisar desempenho
            }
          })
        }, 100)
      })
    },
    enviar () {
      this.isSending = true
      // if (this.pointer >= 0) return
      this.pointer++
      if (this.pointer > (this.lotes.length - 1)) {
        this.isSending = false
        this.pointer = -1
        this.load(this.$leilaoId)
        return
      }
      this.asyncSend(this.lotes[this.pointer], this.pointer)
    },
    asyncSend (lote, index) {
      if (lote.checked) {
        this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {sending: true}))
        Service.enviaAvisosComunicacao(lote.id)
          .then((response) => {
            this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {sending: false, sended: true}))
            this.enviar()
          })
          .catch((error) => {
            this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {sending: false, sendedError: error}))
            this.enviar()
          })
      } else {
        this.enviar()
      }
    }
  },
  components: {}
}
</script>

<template>
  <div>
    <div class="side-panel-overlay" @click="close" :class="{'open': open}">
    </div>
    <div class="view-container" :class="{'open': open}">
      <span @click="close" class="side-panel-close" title="Close">
        <span class="side-panel-close-inner"></span>
      </span>
      <span class="side-panel-print side-panel-print-visible" title="Print"></span>
      <div class="panel-rest wrapper overflow-auto">
        <div v-if="loading">
          Verificando ações a serem executadas... <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div class="w-full" v-else>

          <div class="m-b row">
            <div class="col-sm-8">
              <div class="m-b-n">
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="tipoEnvio.vendidos" @click="checkTipos('vendidos', 6)" tabindex="0"
                         aria-checked="false"
                         aria-invalid="false"><i></i> Enviar Aviso Vendido
                </label>
              </div>
              &nbsp; &nbsp;
              <div class="m-b-n">
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="tipoEnvio.condicionais" @click="checkTipos('condicionais', 7)"
                         tabindex="0"
                         aria-checked="false"
                         aria-invalid="false"><i></i> Enviar Aviso Condicionais
                </label>
              </div>
              &nbsp; &nbsp;
              <div class="m-b-xs">
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="tipoEnvio.rejeitados" @click="checkTipos('rejeitados', 9)"
                         tabindex="0"
                         aria-checked="false"
                         aria-invalid="false"><i></i> Enviar Aviso Rejeitados
                </label>
              </div>
            </div>
            <div class="col-sm-4">
              <u-button :disabled="isSending" class="btn btn-dark pull-right" @click="enviar"><i
                class="fa fa-envelope m-r-xs"></i> Enviar
              </u-button>
            </div>
          </div>

          <table class="table table-clicked table-striped bg-white b-a">
            <thead>
            <tr>
              <th style="width: 30px">
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="selecionarTudo" @click="selectAll" tabindex="0"
                         aria-checked="false"
                         aria-invalid="false"><i></i>
                </label>
              </th>
              <th>LT</th>
              <th>Título</th>
              <th>Comunicados</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="lote in lotes">
              <td>
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="lote.checked" tabindex="0"
                         aria-checked="false"
                         aria-invalid="false">
                  <i></i>
                </label>
              </td>
              <td>{{ lote.numero }}</td>
              <td>{{ lote.titulo }}</td>
              <td style="white-space: nowrap">
                ({{ lote.comunicadosEnviados }})
                <div style="font-size: 12px; " v-for="com in lote.comunicacao" v-if="!com.cancelado">
                  {{moment(com.data.date).format('L')}} {{moment(com.data.date).format('LTS')}} -
                  <span v-if="com.tipo === 0">
                    <strong class="text-danger"
                            v-if="com.dados && com.dados.pagamentoPendente"> Cobrança de pagamento pendente</strong>
                    <span v-else>Cobrança</span>
                  </span>
                  <span v-if="com.tipo === 1">Baixa oferta</span>
                  <span v-if="com.tipo === 2">Condicional</span>
                  <span v-if="com.tipo === 3" class="text-warning">Cobrança Desistência</span>
                  <span v-if="com.tipo === 4" class="text-danger">Informe Negativação</span>
                  - {{com.dados.emails && com.dados.emails[0]}}
                </div>
              </td>
              <td style="background: #000000" :style="{'color': getStatus[lote.status].color}">
                {{ getStatus[lote.status].titulo }}
                <div v-if="lote.sending" style="color: cyan"><i class="fa fa-spinner fa-spin"></i> Enviando</div>
                <div v-if="lote.sendedError" style="color: red">{{lote.sendedError}}</div>
                <div v-if="lote.sended" style="color: greenyellow" class="text-nowrap">
                  <i class="fa fa-check"></i>
                  Enviado com sucesso!
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// EmailsAutomaticosView.vue?317af6a3